import { render, staticRenderFns } from "./AppCarousel.vue?vue&type=template&id=0b0fbe64&scoped=true"
import script from "./AppCarousel.vue?vue&type=script&lang=js"
export * from "./AppCarousel.vue?vue&type=script&lang=js"
import style0 from "./AppCarousel.vue?vue&type=style&index=0&id=0b0fbe64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0fbe64",
  null
  
)

export default component.exports